import * as React from "react";

import { Section, SectionTitle } from "../section";

import { CategoryGrid } from "./category-grid";
import { popularCategories_defaultCategories } from "./default-categories";
import { InitialStateMinimumRequirements_PopularCategories } from "./initial-state-minimum-requirements";
import { PopularCategories_CategoryInterface } from "./model";

interface PopularCategoriesProps {
  categories?: PopularCategories_CategoryInterface[];
  useInitialState: () => {
    initialState: InitialStateMinimumRequirements_PopularCategories;
  };
  hideDefaultTitle?: boolean;
}

export const PopularCategories: React.FunctionComponent<
  PopularCategoriesProps
> = (props) => {
  const categories = React.useMemo(() => {
    return props.categories || popularCategories_defaultCategories;
  }, [props.categories]);
  return (
    <Section className="popular-categories" shaded>
      {!props.hideDefaultTitle ? (
        <SectionTitle showDecorators>{`Popular Categories`}</SectionTitle>
      ) : null}
      <CategoryGrid
        categories={categories}
        useInitialState={props.useInitialState}
      />
    </Section>
  );
};
